// Partner & Vendor CRM + Referrals vocabularies (PROMPT 10)

export const PARTNER_TYPES = [
  { value: "senior_living_community", label: "Senior living community" },
  { value: "assisted_living", label: "Assisted living facility" },
  { value: "retirement_residence", label: "Retirement residence" },
  { value: "home_care", label: "Home care provider" },
  { value: "contractor", label: "Contractor" },
  { value: "accessibility_renovation", label: "Accessibility renovation company" },
  { value: "real_estate_investor", label: "Real estate investor" },
  { value: "realtor", label: "Realtor" },
  { value: "wholesaler", label: "Wholesaler" },
  { value: "estate_sale", label: "Estate sale company" },
  { value: "auction_company", label: "Auction company" },
  { value: "moving_company", label: "Moving company" },
  { value: "storage_company", label: "Storage company" },
  { value: "junk_removal", label: "Junk removal" },
  { value: "lawyer", label: "Lawyer" },
  { value: "financial_advisor", label: "Financial advisor" },
  { value: "insurance", label: "Insurance contact" },
  { value: "benefits_consultant", label: "Medicaid / Medicare / HUD consultant" },
  { value: "canadian_support_consultant", label: "Canadian provincial support consultant" },
  { value: "trilogy_fitness", label: "Trilogy Sports & Fitness" },
  { value: "church_community", label: "Church / community partner" },
  { value: "referral_source", label: "Referral source" },
  { value: "other", label: "Other" },
];

export const PARTNER_PIPELINE = [
  { value: "prospect", label: "New partner prospect", tone: "khaki" },
  { value: "contacted", label: "Contacted", tone: "sky" },
  { value: "meeting_booked", label: "Meeting booked", tone: "sky" },
  { value: "agreement_sent", label: "Agreement sent", tone: "amber" },
  { value: "agreement_signed", label: "Agreement signed", tone: "navy" },
  { value: "active_partner", label: "Active partner", tone: "green" },
  { value: "referred_case", label: "Referred case", tone: "navy" },
  { value: "revenue_generated", label: "Revenue generated", tone: "green" },
  { value: "paused", label: "Paused / inactive", tone: "gray" },
];

export const AGREEMENT_STATUSES = [
  { value: "none", label: "No agreement", tone: "gray" },
  { value: "pending", label: "Pending", tone: "amber" },
  { value: "active", label: "Active", tone: "green" },
  { value: "expired", label: "Expired", tone: "red" },
];

export const ACTIVE_STATUSES = [
  { value: "active", label: "Active", tone: "green" },
  { value: "inactive", label: "Inactive", tone: "gray" },
  { value: "pending", label: "Pending", tone: "amber" },
];

export const REFERRAL_STATUSES = [
  { value: "draft", label: "Draft", tone: "gray" },
  { value: "sent", label: "Sent", tone: "sky" },
  { value: "accepted", label: "Accepted", tone: "navy" },
  { value: "in_progress", label: "In progress", tone: "navy" },
  { value: "completed", label: "Completed", tone: "green" },
  { value: "revenue_pending", label: "Revenue pending", tone: "amber" },
  { value: "revenue_received", label: "Revenue received", tone: "green" },
  { value: "declined", label: "Declined", tone: "red" },
  { value: "cancelled", label: "Cancelled", tone: "gray" },
];

export const COUNTRIES = [
  { value: "USA", label: "United States" },
  { value: "Canada", label: "Canada" },
];

export const QUALITY_RATINGS = [
  { value: "5", label: "5 — Excellent" },
  { value: "4", label: "4 — Great" },
  { value: "3", label: "3 — Good" },
  { value: "2", label: "2 — Fair" },
  { value: "1", label: "1 — Needs review" },
];

export const TONE = {
  red: { bg: "rgba(156,30,34,0.10)", color: "#9C1E22", border: "rgba(156,30,34,0.24)" },
  amber: { bg: "rgba(183,121,31,0.14)", color: "#9A6516", border: "rgba(183,121,31,0.30)" },
  sky: { bg: "rgba(155,185,206,0.25)", color: "#1C4358", border: "rgba(155,185,206,0.45)" },
  navy: { bg: "rgba(28,67,88,0.10)", color: "#1C4358", border: "rgba(28,67,88,0.20)" },
  green: { bg: "rgba(47,125,90,0.12)", color: "#256B4B", border: "rgba(47,125,90,0.28)" },
  khaki: { bg: "rgba(196,200,155,0.35)", color: "#5A5E2E", border: "rgba(196,200,155,0.60)" },
  gray: { bg: "rgba(75,85,99,0.10)", color: "#4B5563", border: "rgba(75,85,99,0.22)" },
};

const prettify = (v) => (v ? String(v).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "");

export const optOf = (arr, val) => arr.find((o) => o.value === val) || null;
export const labelOf = (arr, val) => optOf(arr, val)?.label || prettify(val);
export const toneOf = (arr, val) => TONE[optOf(arr, val)?.tone || "gray"];
export const partnerTypeLabel = (val) => labelOf(PARTNER_TYPES, val);
